module.exports = __webpack_public_path__ + "static/media/twitter.578937b3.webp";